export const siteMeta = {
  brand: "吃瓜热门",
  slogan: "本周焦点 · 近期动态 · 一次看够",
  desc: "聚焦吃瓜热门本周焦点，汇总近期动态与焦点事件。",
  contactEmail: "chigua@chiguaremen.com",
  weekly: "2026年第36周（08.31 – 09.06）",
  updateTime: "2026-09-07 09:30",
};

export const hotTags = [
  "新剧开播",
  "综艺名场面",
  "片场路透",
  "颁奖礼看点",
  "人物访谈",
  "社会热议",
  "近期动态",
  "本周焦点",
];

export const categories = [
  { key: "all", label: "全部瓜料" },
  { key: "ent", label: "娱乐八卦" },
  { key: "film", label: "影视综艺" },
  { key: "people", label: "人物话题" },
  { key: "society", label: "社会热议" },
];

export const feedItems = [
  {
    id: "f1",
    cat: "ent",
    title: "某顶流新剧开机被爆「番位之争」，剧组连夜发声明回应",
    excerpt: "古装大制作刚官宣阵容，两位主演方就片头署名顺序展开拉锯，片方表态「以角色为主」，话题火速冲上本周焦点榜。",
    image: "https://readdy.ai/api/search-image?query=Editorial%20celebrity%20gossip%20magazine%20cover%20collage%20with%20warm%20coral%20and%20amber%20tones%2C%20stylized%20drama%20theatre%20curtain%20and%20spotlight%2C%20film%20reel%20and%20clapperboard%20accents%2C%20soft%20cream%20background%2C%20high%20contrast%2C%20fashion%20editorial%20style&width=800&height=500&seq=feed-ent-01&orientation=landscape",
    heat: 982000,
    tag: "爆",
    date: "09-06",
    time: "21:40",
  },
  {
    id: "f2",
    cat: "ent",
    title: "网友考古十年前红毯旧照，一条「礼服回忆杀」带火话题",
    excerpt: "一段十年前电影节红毯合集被疯狂转发，网友直呼「时代滤镜最强」，当年造型纷纷被翻出来重新打分。",
    image: "https://readdy.ai/api/search-image?query=Retro%20film%20festival%20red%20carpet%20collage%20in%20warm%20vintage%20tones%2C%20stylized%20editorial%20poster%2C%20elegant%20evening%20gown%20silhouettes%20and%20spotlights%2C%20glitter%20and%20paper%20confetti%2C%20cream%20and%20amber%20background%2C%20fashion%20magazine%20style%20high%20detail&width=800&height=500&seq=feed-ent-02&orientation=landscape",
    heat: 661000,
    tag: "热",
    date: "09-05",
    time: "18:12",
  },
  {
    id: "f3",
    cat: "film",
    title: "口碑黑马《长风照夜》完结，结局三连反转被评「高开疯走」",
    excerpt: "都市悬疑剧本周迎来大结局，最后三集连续反转让剧粉直呼意犹未尽，相关讨论登上本周焦点与近期动态双榜。",
    image: "https://readdy.ai/api/search-image?query=Suspense%20drama%20movie%20poster%20art%20in%20warm%20night%20tones%2C%20neon%20city%20skyline%20silhouette%20with%20amber%20and%20coral%20lighting%2C%20cinematic%20noir%20atmosphere%2C%20stylized%20illustration%2C%20deep%20shadows%20and%20dramatic%20contrast%2C%20editorial%20promo%20art&width=800&height=500&seq=feed-film-01&orientation=landscape",
    heat: 845000,
    tag: "爆",
    date: "09-05",
    time: "22:05",
  },
  {
    id: "f4",
    cat: "film",
    title: "新综《默契研究所》首播破纪录，全员「嘴替」笑点密集",
    excerpt: "观察类真人秀首播即刷新平台同期纪录，嘉宾临场反应被网友剪成名场面合集，节目方顺势放出更多花絮。",
    image: "https://readdy.ai/api/search-image?query=Playful%20variety%20show%20studio%20scene%20in%20bright%20warm%20colors%2C%20colorful%20set%20design%20with%20amber%20and%20cream%20tiles%2C%20confetti%20and%20smiley%20props%2C%20stylized%20editorial%20illustration%2C%20cheerful%20entertainment%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=feed-film-02&orientation=landscape",
    heat: 702000,
    tag: "热",
    date: "09-04",
    time: "20:33",
  },
  {
    id: "f5",
    cat: "people",
    title: "老戏骨直播首秀聊往事，一句「慢一点挺好」刷屏评论区",
    excerpt: "多年未露面的实力派演员开启直播首秀，谈年少北漂与中年沉淀，质朴发言被无数网友截屏珍藏。",
    image: "https://readdy.ai/api/search-image?query=Warm%20intimate%20studio%20portrait%20lighting%20scene%2C%20veteran%20actor%20silhouette%20sitting%20by%20amber%20lamp%2C%20film%20reel%20and%20script%20on%20table%2C%20stylized%20editorial%20illustration%2C%20cream%20and%20coral%20tone%2C%20documentary%20magazine%20feel%2C%20high%20detail&width=800&height=500&seq=feed-ppl-01&orientation=landscape",
    heat: 590000,
    tag: "新",
    date: "09-04",
    time: "15:48",
  },
  {
    id: "f6",
    cat: "people",
    title: "唱作人新专试听会举办，台下泪崩场景登上人物话题榜",
    excerpt: "独立唱作人发布个人第三张专辑，现场试听会氛围感人，多首歌曲被乐迷标记为「年度单曲循环」。",
    image: "https://readdy.ai/api/search-image?query=Indie%20musician%20acoustic%20listening%20session%20in%20warm%20golden%20light%2C%20vinyl%20record%20and%20guitar%20accents%2C%20audience%20hands%20up%20silhouette%2C%20stylized%20editorial%20illustration%2C%20amber%20cream%20palette%2C%20concert%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=feed-ppl-02&orientation=landscape",
    heat: 475000,
    tag: "热",
    date: "09-03",
    time: "19:20",
  },
  {
    id: "f7",
    cat: "society",
    title: "某市推出「夜校」升级版，年轻人扎堆报名成社会热议",
    excerpt: "夜校课程从传统技能扩展至小众兴趣，名额开放即被抢空，关于「充电式社交」的讨论成为本周社会热议焦点。",
    image: "https://readdy.ai/api/search-image?query=Modern%20community%20evening%20school%20classroom%20in%20warm%20evening%20light%2C%20young%20people%20learning%20crafts%20and%20reading%2C%20stylized%20editorial%20illustration%2C%20amber%20and%20cream%20tones%2C%20warm%20social%20documentary%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=feed-soc-01&orientation=landscape",
    heat: 738000,
    tag: "爆",
    date: "09-03",
    time: "11:05",
  },
  {
    id: "f8",
    cat: "society",
    title: "「打包剩菜的风气」引热议，反浪费倡议再度被顶上焦点",
    excerpt: "一条关于宴席剩菜如何处理的街采走红，带动「光盘行动」话题重回社会热议，网友纷纷晒出自己打包日常。",
    image: "https://readdy.ai/api/search-image?query=Warm%20cafeteria%20table%20with%20reusable%20takeaway%20boxes%20and%20eco%20bags%2C%20hand%20holding%20leftover%20container%2C%20stylized%20editorial%20illustration%2C%20cream%20amber%20green%20tones%2C%20social%20movement%20magazine%20style%2C%20high%20detail&width=800&height=500&seq=feed-soc-02&orientation=landscape",
    heat: 428000,
    tag: "新",
    date: "09-02",
    time: "16:30",
  },
];

export const ranking = [
  { rank: 1, title: "某顶流新剧番位之争，剧组声明回应", cat: "娱乐八卦", heat: 982000, trend: "up" },
  { rank: 2, title: "《长风照夜》大结局三连反转", cat: "影视综艺", heat: 845000, trend: "up" },
  { rank: 3, title: "某市夜校升级版报名爆满", cat: "社会热议", heat: 738000, trend: "up" },
  { rank: 4, title: "《默契研究所》首播破纪录", cat: "影视综艺", heat: 702000, trend: "up" },
  { rank: 5, title: "十年红毯旧照回忆杀走红", cat: "娱乐八卦", heat: 661000, trend: "flat" },
  { rank: 6, title: "老戏骨直播首秀金句刷屏", cat: "人物话题", heat: 590000, trend: "up" },
  { rank: 7, title: "唱作人新专试听会泪崩现场", cat: "人物话题", heat: 475000, trend: "down" },
  { rank: 8, title: "「打包剩菜」反浪费倡议回热", cat: "社会热议", heat: 428000, trend: "down" },
];

export const timeline = [
  { topic: "番位之争", date: "09-06", text: "多方消息源先后发声，片方发布正式声明，本周焦点热度继续走高，粉丝团陆续表态尊重剧组安排。" },
  { topic: "长风照夜", date: "09-05", text: "大结局上线，三连反转引爆讨论，主创连麦直播答疑，播放平台放出番外拍摄计划。" },
  { topic: "默契研究所", date: "09-04", text: "首播以破纪录收视收官，节目组追加会员加更版，嘉宾名场面合集播放量破亿。" },
  { topic: "夜校升级版", date: "09-03", text: "首批报名通道开放即满，官方回应将增设第二批名额，并把热门课程排期公开征求建议。" },
  { topic: "唱作人新专", date: "09-03", text: "试听会视频流出，数字专辑开启预售，多条曲目登上音乐平台飙升榜。" },
  { topic: "红毯旧照", date: "09-02", text: "考古合集二次发酵，多位造型师下场复盘当年造型，怀旧话题持续挂在焦点榜。" },
];

export const specials = [
  {
    id: "s1",
    title: "本周焦点深读：一场「番位之争」背后，是内娱排名的攻守战",
    tag: "深度盘点",
    read: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20feature%20illustration%20about%20entertainment%20industry%20ranking%20debate%2C%20chessboard%20and%20spotlight%20metaphor%20with%20clapperboard%2C%20warm%20coral%20amber%20palette%2C%20magazine%20spread%20style%2C%20cream%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=1200&height=700&seq=spec-01&orientation=landscape",
    summary: "我们从一条开机官宣出发，梳理番位争论的由来、片方应对与行业潜规则，帮你理性吃本周最火这口瓜。",
    points: ["一张官宣图引发的排位争论", "署名顺序背后的行业惯例", "声明里藏着哪些信息量"],
  },
  {
    id: "s2",
    title: "《长风照夜》：三集三反转，结局到底藏了几层叙事",
    tag: "剧集拆解",
    read: "10 分钟",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20suspense%20drama%20analysis%2C%20layered%20cinematic%20frames%20and%20film%20strips%20unfolding%2C%20neon%20city%20and%20magnifying%20glass%2C%20warm%20night%20amber%20tones%2C%20magazine%20essay%20style%2C%20high%20detail&width=1200&height=700&seq=spec-02&orientation=landscape",
    summary: "从人物动机到伏笔回收，我们带你把大结局的每一层反转拆开看，帮助你更懂这部剧为何能持续霸榜。",
    points: ["第一重反转：真凶的身份", "第二重反转：动机的真相", "第三重反转：开放的尾声"],
  },
  {
    id: "s3",
    title: "夜校升温观察：年轻人为什么爱上「上课式社交」",
    tag: "社会观察",
    read: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20young%20people%20attending%20night%20classes%20and%20socializing%2C%20warm%20lamp%20lit%20classroom%2C%20books%20and%20plants%20accents%2C%20cream%20amber%20tones%2C%20trend%20observation%20magazine%20style%2C%20high%20detail&width=1200&height=700&seq=spec-03&orientation=landscape",
    summary: "「上课式社交」为何在这批年轻人里流行？我们结合报名数据和现场观察，聊聊这波社会热议背后的需求。",
    points: ["从卷技能到卷兴趣的转向", "低门槛社交的新解法", "夜校为何能持续翻红"],
  },
];

export const faqs = [
  {
    q: "吃瓜热门多久更新一次？",
    a: "我们每日持续跟进，并每逢周五推出完整的「本周吃瓜焦点盘点」，汇总近7天最值得关注的娱乐八卦与社会热议事件。",
  },
  {
    q: "本周焦点盘点包含哪些栏目？",
    a: "涵盖娱乐八卦、影视综艺、人物话题与社会热议四大栏目，并通过热榜、近期动态时间线和深度盘点三种方式呈现。",
  },
  {
    q: "内容是否经过核实？",
    a: "我们坚持多方信源交叉核对，对存疑传闻明确标注「网传·待证实」，只为读者提供来源相对清晰、可信度更高的近期动态信息。",
  },
  {
    q: "如何不错过最新瓜料？",
    a: "你可以在页面底部订阅每周瓜报，我们会在每周盘点发布后第一时间把本期焦点和完整链接发送到你的邮箱。",
  },
];

export const testimonials = [
  { name: "阿鲸", role: "追剧博主", text: "每周五晚上蹲这份盘点已成习惯，分类清楚、进展有来龙去脉，比我自己翻热搜高效太多。" },
  { name: "小北", role: "互联网从业者", text: "午休十分钟就能把本周瓜补完，近期动态时间线对「断片式吃瓜」特别友好。" },
  { name: "Momo", role: "吃瓜十级选手", text: "最难得的是不炒冷饭，每期都会整理最新进展而不是只抄旧闻，这个更新节奏我服。" },
];

export const stats = [
  { num: "每周盘点", label: "覆盖 4 大栏目" },
  { num: "70+", label: "本期热点词条" },
  { num: "10 分钟", label: "快速看完本周" },
  { num: "每日", label: "持续跟进动态" },
];